import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    MomList: { loading: false, data: null, error: null },
};

export const MomSlice = createSlice({
    name: "mom",
    initialState,
    reducers: {
        fetchMomListRequest: (state, action) => {
            state.MomList.loading = true;
            state.MomList.error = null;
        },
        fetchMomListSuccess: (state, action) => {
            state.MomList.data = action.payload;
            state.MomList.loading = false;
            state.MomList.error = null;
        },
        fetchMomFailure: (state, action) => {
            state.MomList.data = null;
            state.MomList.loading = false;
            state.MomList.error = action.payload;
        },
    },
});

export const {
    fetchMomListRequest,
    fetchMomListSuccess,
    fetchMomFailure,
} = MomSlice.actions;

export const getMomListState = (store) => 
    store.mom?.MomList;

export default MomSlice.reducer;
